module.exports = __webpack_public_path__ + "img/rangerDalle.8796dae8.png";